import React from 'react';
export function Guarantee() {
  return <section className="w-full bg-white text-fondo-principal py-section px-4 text-center" data-id="element-83">
      <div className="text-6xl mb-4" data-id="element-84">🛡️</div>
      <h2 className="text-2xl font-bold mb-4" data-id="element-85">
        Garantía 7 días — Sin preguntas
      </h2>
      <p className="text-gray-700 mb-6 max-w-sm mx-auto" data-id="element-86">
        Abrís el sistema. Lo usás. Si en 7 días no es lo que esperabas, te
        devolvemos el 100% sin formularios, sin drama.
      </p>
      <div className="inline-block bg-green-100 text-green-800 font-bold px-4 py-2 rounded-full text-sm" data-id="element-87">
        Tasa de devoluciones: menos del 1%.
      </div>
    </section>;
}